import { DatabasesExternalAssetsDisplayGridRowData } from '@tableau/data-catalog-client-components';
import { Action } from 'redux';

import { UngroupDatabases } from '../../../bootstrap/redux/actions/AppActionTypes';
import { IExplorableItemTypeInfo } from '../../../spacesPlatform/models/resourceInfoParts';

export type DatabaseForUngrouping =
  IExplorableItemTypeInfo<'database' | 'databaseWithCrass'> &
  Pick<DatabasesExternalAssetsDisplayGridRowData, 'name' | 'luid' | 'isGrouped'>;

export interface UngroupDatabasesAction extends Action {
  readonly database: DatabaseForUngrouping;
}

export function ungroupDatabasesAction(database: DatabaseForUngrouping): UngroupDatabasesAction {
  return {
    type: UngroupDatabases,
    database
  };
}
